module.exports = __webpack_public_path__ + "static/media/logo-dw.4baa8736.jpg";